import './App.css';
import HomeView from "./View/HomeView";
import PrHomeView from "./View/Particular/PrHomeView";
import BsHomeView from "./View/Business/BsHomeView";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ApplicationView from "./View/Business/ApplicationView";
import { ApplicationContextProvider } from "./Provider/ApplicationProvider";
import AdminView from "./View/Business/AdminView";
import {AuthProvider} from "./Provider/AuthProvider";
import LoginView from "./View/LoginView";
import OrganisationView from "./View/OrganisationView";
import ErrorView from "./View/ErrorView";
import PaymentView from "./View/PaymentView";
import PaymentCheckView from "./View/PaymentCheckView";
import TestView from "./View/TestView";
import HomePageView from "./View/HomePageView";
import WithdrawalCheckView from "./View/WithdrawalCheckView";
import WithdrawalRequestView from "./View/withdrawalRequestView";
import InvitedView from "./View/Business/InvitedView";
import ReportView from "./View/Business/ReportView";
import WithdrawalConfirmationView from "./View/Business/WithdrawalConfirmationView";
function App() {
  return (
      <AuthProvider>
          <ApplicationContextProvider>
              <Router>
                  <Routes>
                      <Route path="/" element={<HomePageView />} />
                      <Route path="/login" element={<LoginView />} />
                      <Route path="/:pageUrl" element={<HomeView />} />
                      <Route path="/admin" element={<AdminView />} />
                      <Route path="/organisation" element={<BsHomeView/>} />
                      <Route path="/application" element={<ApplicationView/>} />
                      <Route path="/particulier" element={<PrHomeView/>} />
                      <Route path="/error-page" element={<ErrorView/>} />
                      <Route path="/create-organisation" element={<OrganisationView/>} />
                      <Route path="/payment" element={<PaymentView/>} />
                      <Route path="/payment-check" element={<PaymentCheckView/>}/>
                      <Route path="/withdrawal-request" element={<WithdrawalRequestView/>}/>
                      <Route path="/withdrawal-check" element={<WithdrawalCheckView/>}/>
                      <Route path="/invited" element={<InvitedView/>}/>
                      <Route path="/report" element={<ReportView/>}/>
                      <Route path="/withdrawal-confirmation" element={<WithdrawalConfirmationView/>}/>
                  </Routes>
              </Router>
          </ApplicationContextProvider>
      </AuthProvider>
  );
}

export default App;
